export const PermissionProperties = {
    PUT: "mgr-properties-classes-**-PUT",
    POST: "mgr-properties-POST",
    DELETE: "mgr-properties-property-classes-**-DELETE",
    GET: "mgr-properties-search-GET",
    GET_UUID: "mgr-properties-classes-**-GET",
    POST_CLASSES: "mgr-properties-classes-**-values-POST",
    DELETE_CLASSES: "mgr-properties-property-**-DELETE",
};